'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {
  INIT: 'redux-localstorage/INIT'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/redux-localstorage/lib/actionTypes.js
// module id = 64
// module chunks = 0